import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';

@Injectable({
  providedIn: 'root'
})
export class SpinnerServiceForUserPromptService {
  private spinnerHiddenSubject = new BehaviorSubject<boolean>(false);
  spinnerInVisible$ = this.spinnerHiddenSubject.asObservable();

  constructor() {}

  setSpinnerSubjectHidden(): void {
    this.spinnerHiddenSubject.next(true);  
  }

  setSpinnerSubjectShown(): void {
    this.spinnerHiddenSubject.next(false);  // spinner shown
  }

  getSpinnerSubjectStatus(): boolean {
    return this.spinnerHiddenSubject.getValue();  // Get current spinner status
  }
}
